// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3WcjX","upload":"Small_upload__Eewvb","imageWrap":"Small_imageWrap__2jPg2","removeBtn":"Small_removeBtn__2ATX9"};